import { Button, Group, Stack, Text, TextInput } from '@mantine/core'
import { useField } from '@mantine/form'
import { modals } from '@mantine/modals'

interface ModalProps {
  onAddItem: (value: string) => void
  item: string
  placeholder: string
  onChangeInput: (
    event: React.ChangeEvent<HTMLInputElement>,
    setValue: (value: string) => void,
  ) => void
}

const AddNewItemModal = ({
  onAddItem,
  item,
  placeholder,
  onChangeInput,
}: ModalProps) => {
  const fieldValue = useField({ initialValue: '', validateOnChange: true })

  const onSave = () => {
    onAddItem(fieldValue.getValue())
    modals.closeAll()
    fieldValue.setValue
  }
  return (
    <Stack>
      <Text size="xl" fw={700} ta="center">
        Add a new {item}
      </Text>
      <Group justify="center" p={20}>
        <TextInput
          placeholder={placeholder}
          w={'80%'}
          {...fieldValue.getInputProps()}
          onChange={(e) => onChangeInput(e, fieldValue.setValue)}
        />
      </Group>
      <Group justify="space-between" p={20}>
        <Button variant="default" onClick={() => modals.closeAll()}>
          {' '}
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave}>
          {' '}
          Save
        </Button>
      </Group>
    </Stack>
  )
}

export const openAddNewItemModal = (props: ModalProps) => {
  return modals.open({
    centered: true,
    size: 'xl',
    withCloseButton: true,
    children: <AddNewItemModal {...props} />,
  })
}
